jQuery(document).ready(function($) {
    // add css class to <nf-field> elements for better targetin
    var nfLoad = setInterval(function() {
        // .nf-form-cont elements are available in the HTML on dom-ready (ninja forms v3 only)
        var forms = $('.nf-form-cont').not('.md-processed');
        if (forms.length) {
            // form contents get added with javascript
            $('.nf-form-wrap', forms).each(function() {
                var formElem = $(this).closest('.nf-form-cont');
                $('.field-marker', this).each(function(i, el) {
                    if (this.className) {
                        var nfElement = $(this).closest('nf-field');
                        $.each(this.className.split(' '), function(i, className) {
                            if (0 === className.indexOf('field-')) {
                                nfElement.addClass(className + '-container');
                            }
                        });
                    }
                });
                formElem.addClass('md-processed');
                formElem.trigger('load');
            })
        } else {
            window.clearInterval(nfLoad);
        }
    }, 100);
});
